// import { configureStore } from '@reduxjs/toolkit';
// import eligibilityReducer from './eligibilitySlice';

// export const store = configureStore({
//   reducer: {
//     eligibility: eligibilityReducer,
//   },
// });

import { configureStore } from "@reduxjs/toolkit";
import visaEligibilityReducer from "./visaEligibilitySlice";

export const store = configureStore({
  reducer: {
    visaEligibility: visaEligibilityReducer,
  },
});
